import React from 'react';
import { Check, X, ChevronRight } from 'lucide-react';
import './style.css';
import ButtonPrimary from '../../atoms/ButtonPrimary/view';

function PlanCard({ plan, onSelect, text, isPopular, loading }) {
    if (!plan) return null;

    const isCurrent = text === 'Plan Actual';
    const inSelectionFlow = !!onSelect && !isCurrent;

    const price = plan.price > 0 ? Number(plan.price).toLocaleString('es-CO') : '0';
    const cycle = plan.billing_cycle === 'anual' ? 'año' : 'mes';

    const features = Object.entries(plan.benefits || {}).map(([key, val]) => ({
        label: val?.label || key.replace(/_/g, ' '),
        included: val?.type === 'limit' ? val.value > 0 : !!val?.value,
        value: val?.type === 'limit' ? val.value : val?.value,
    }));

    const limits = [
        { label: 'Usuarios', value: plan.max_users },
        { label: 'Sucursales', value: plan.max_branches },
        { label: 'Documentos', value: plan.max_documents },
    ];

    return (
        <div className={`land-pagos ${isPopular ? 'is-popular' : ''} ${isCurrent ? 'is-current' : ''}`}>
            {isPopular && <span className="land-popular-badge">Más Popular</span>}

            <div className="land-plan-inner">
                <p className="land-plan-title">
                    {plan.name?.charAt(0).toUpperCase() + plan.name?.slice(1)}
                </p>

                {plan.price > 0 ? (
                    <p className="land-plan-price">
                        <span className="land-plan-currency">$</span>
                        <span className="land-plan-amount">{price}</span>
                        <span className="land-plan-cycle">/ {cycle}</span>
                    </p>
                ) : (
                    <p className="land-plan-price land-plan-free">Gratis</p>
                )}

                <div className="land-plan-limits">
                    {limits.map((l) => (
                        <span key={l.label} className="land-plan-limit">
                            {l.label}: <strong>{l.value}</strong>
                        </span>
                    ))}
                </div>

                {inSelectionFlow && (
                    <div className="land-btn-wrapper">
                        <ButtonPrimary
                            onClick={() => onSelect(plan)}
                            disabled={loading}
                        >
                            {loading ? 'Procesando...' : (text || 'Elegir este plan')}
                            <ChevronRight size={16} />
                        </ButtonPrimary>
                    </div>
                )}
                {isCurrent && (
                    <div className="land-btn-wrapper">
                        <button className="land-start-btn btn-current" disabled>
                            Plan Actual
                        </button>
                    </div>
                )}
            </div>

            <hr className="land-divider" />

            <div className="land-features-list">
                <p className="land-features-title">Incluye</p>
                {features.map((f, i) => (
                    <p key={i} className={`land-plan-item ${!f.included ? 'land-plan-item--muted' : ''}`}>
                        {f.included
                            ? <Check size={16} className="land-plan-check" />
                            : <X size={16} className="land-plan-cross" />
                        }
                        {f.label}{f.value && typeof f.value === 'number' ? ` (${f.value})` : ''}
                    </p>
                ))}
            </div>
        </div>
    );
}

export default PlanCard;
